import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  Form,
  Input,
  List,
  message,
  Modal,
  Result,
  Row,
  Select,
  Spin,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { ContentBox } from "../../components/layout/content";
import { LoginedLayout } from "../../components/layout/loginLayout";
import { HeaderTitle } from "../../components/styled-components";
import { GET, POST } from "../../services";
import { EDIT_ITEM_MUTI_ORDER, GET_ORDER_BY_SKU, GETALLPRODUCT } from "../../services/path";

interface Product {
  SKU: string;
  itemName: string;
  sizeID: number;
  sizeName: string;
}

interface OrderData {
  no: string;
  sku: string;
  itemName: string;
  itemSize: string;
  qty: number;
  price: number;
  newAdd: boolean;
  orderNo: string;
  runNumber: number;
  trackingNo: string;
  soNo: string;
  optStatusId: number;
  status: string;
  invoiceNo: string;
}

interface ResultJournal {
  journalId: string;
  orderNo: string;
}
const EditmultiOrder = () => {
  const [selectedOrders, setSelectedOrders] = useState<OrderData[]>([]);
  const [selectedSku, setSelectedSku] = useState<string>("");
  const [selectedNameSku, setSelectedNameSku] = useState<string>("");
  const [selectedSkunew, setSelectedSkunew] = useState<string>("");
  const [selectedNameSkunew, setSelectedNameSkunew] = useState<string>("");
  const [searchSku, setSearchSku] = useState<boolean>(false);
  const [remark, setRemark] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [allProduct, setAllProduct] = useState<Product[]>([]);
  const [order, setOrder] = useState<OrderData[]>([]);
  const [open, setOpen] = useState(false);
  const [resultJournal, setResultJournal] = useState<ResultJournal[]>([]);
  const [resultJournalerror, setResultJournalerror] = useState<ResultJournal[]>([]);
  const { Option } = Select;
  const handleRemark = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRemark(e.target.value);
  };

  const columns = [
    {
      title: "Select",
      key: "select",
      render: (_: any, record: OrderData) => (
        <Checkbox
          checked={selectedOrders.some((item) => item.orderNo === record.orderNo)}
          onChange={(e) => handleCheckboxChange(record, e.target.checked)}
        />
      ),
    },
    {
      title: "Order Number",
      dataIndex: "orderNo",
      key: "orderNo",
    },
    {
      title: "Sales ID",
      dataIndex: "soNo",
      key: "soNo",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Invoice",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: "Name SKU",
      dataIndex: "itemName",
      key: "itemName",
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
    },
  ];

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (selectedOrders.length === 0) {
        message.error(`กรุณาเลือก order `);
      } else if (remark === "") {
        message.error("กรุณากรอกรายละเอียด!");
      } else if (selectedSkunew === "") {
        message.error("กรุณาเลือก SKU ที่ต้องการเปลี่ยน!");
      } else {
        const selectedItem = allProduct.find((item) => item.SKU === selectedSkunew);
        const data = {
          oldSku: selectedSku,
          oldItemName: selectedNameSku,
          newSku: selectedSkunew,
          newItemName: selectedNameSkunew,
          sizeName: selectedItem?.sizeName,
          remark: remark,
          orderSwap: selectedOrders.map((item) => ({
            no: parseInt(item.no, 10),
            orderNo: item.orderNo,
            sku: item.sku,
            soNo: item.soNo,
          })),
        };

        const result = await POST(EDIT_ITEM_MUTI_ORDER, data);
        if (result.success === true) {
          result.result.success !== null
            ? setResultJournal(result.result.success)
            : setResultJournal([]);
          result.result.errors !== null
            ? setResultJournalerror(result.result.errors)
            : setResultJournalerror([]);

          setOpen(true);
        }
      }
    } catch (error: any) {
      message.error(error.data);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (redcord: OrderData, checked: boolean) => {
    setSelectedOrders((prev) => {
      if (checked && selectedOrders.length < 5) {
        return [...prev, redcord]; // Add to selected orders
      } else {
        return prev.filter((item) => item.orderNo !== redcord.orderNo); // Remove from selected orders
      }
    });
  };

  const handleSkuChange = (value: string) => {
    setSelectedSku(value);
    setSelectedOrders([]);
    setSearchSku(true);
    const selectedItem = allProduct.find((item) => item.SKU === value);
    if (selectedItem) {
      setSelectedNameSku(selectedItem.itemName); // Set the corresponding namesku
    }
  };

  const handleNameChange = (value: string) => {
    setSelectedNameSku(value);
    setSelectedOrders([]);
    setSearchSku(true);
    const selectedItem = allProduct.find((item) => item.itemName === value);
    if (selectedItem) {
      setSelectedSku(selectedItem.SKU); // Set the corresponding namesku
    }
  };

  const handleSkuChangenew = (value: string) => {
    setSelectedSkunew(value);
    const selectedItem = allProduct.find((item) => item.SKU === value);
    if (selectedItem) {
      setSelectedNameSkunew(selectedItem.itemName); // Set the corresponding namesku
    }
  };

  const handleNameChangenew = (value: string) => {
    setSelectedNameSkunew(value);
    const selectedItem = allProduct.find((item) => item.itemName === value);
    if (selectedItem) {
      setSelectedSkunew(selectedItem.SKU); // Set the corresponding namesku
    }
  };

  const fetchAllProduct = async () => {
    try {
      const result = await GET(GETALLPRODUCT);
      setAllProduct(result.result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAllProduct();
  }, []);

  const fetchOrderBySku = async () => {
    try {
      setLoading(true);
      const data = await GET(GET_ORDER_BY_SKU(selectedSku));
      const { result } = data;
      if (!result.length) {
        setOrder([]);
        message.warning(`ไม่พบออเดอร์ที่มี SKU: ${selectedSku} นี้`);
      } else {
        setOrder(result.filter((item: OrderData) => item.optStatusId === 10));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedSku !== "") {
      fetchOrderBySku();
    }
  }, [selectedSku]);

  const handleClear = () => {
    setOpen(false);
    setSelectedNameSku("");
    setSelectedNameSkunew("");
    setSelectedSku("");
    setSelectedSkunew("");
    setSelectedOrders([]);
    setOrder([]);
    setResultJournal([]);
    setRemark("");
    window.location.reload();
  };
  return (
    <LoginedLayout>
      <ContentBox>
        <Spin spinning={loading}>
          <HeaderTitle>
            <h2>Edit Multi Order</h2>
          </HeaderTitle>
          <div>
            <Form layout="vertical" style={{ margin: "50px 50px" }}>
              <Row gutter={10}>
                <Col span={12}>
                  <Form.Item label="SKU">
                    <Select
                      showSearch
                      value={selectedSku}
                      onChange={handleSkuChange}
                      placeholder="Select SKU"
                      filterOption={(input, option) =>
                        (option?.value as string).toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {allProduct.map((item, i: number) => (
                        <Option key={`${i}-${item.SKU}`} value={item.SKU}>
                          {item.SKU}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Item Name">
                    <Select
                      showSearch
                      value={selectedNameSku}
                      onChange={handleNameChange}
                      placeholder="Select NameSKU"
                    >
                      {allProduct.map((item, i: number) => (
                        <Option key={`${i}-${item.itemName}`} value={item.itemName}>
                          {item.itemName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Form layout="vertical" style={{ margin: "50px 50px" }}>
              <Row gutter={10}>
                <Col span={12}>
                  <Form.Item label="SKU New">
                    <Select
                      showSearch
                      value={selectedSkunew}
                      onChange={handleSkuChangenew}
                      placeholder="Select SKU"
                      filterOption={(input, option) =>
                        (option?.value as string).toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {allProduct
                        .filter((item) => item.SKU !== selectedSku)
                        .map((item, i: number) => (
                          <Option key={`${i}-${item.SKU}`} value={item.SKU}>
                            {item.SKU}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Item Name New">
                    <Select
                      showSearch
                      value={selectedNameSkunew}
                      onChange={handleNameChangenew}
                      placeholder="Select NameSKU"
                      filterOption={(input, option) =>
                        (option?.value as string).toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {allProduct
                        .filter((item) => item.SKU !== selectedSku)
                        .map((item, i: number) => (
                          <Option key={`${i}-${item.itemName}`} value={item.itemName}>
                            {item.itemName}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="Remark">
                    <Input maxLength={250} showCount onChange={handleRemark} value={remark} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          {searchSku && (
            <>
              <div className="table-data">
                <Table<OrderData> dataSource={order} columns={columns} rowKey="orderNo" />
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  style={{ color: "#ffffff", backgroundColor: "#34C759" }}
                >
                  บันทึก
                </Button>
              </div>
            </>
          )}
        </Spin>
      </ContentBox>
      {open && (
        <Modal open={open} footer={null} closeIcon={null}>
          <Result
            status="success"
            title="แก้ไขข้อมูลสำเร็จ !"
            subTitle={
              <>
                {" "}
                <Descriptions>
                  <Descriptions.Item label="SKU เก่า" span={3}>
                    {selectedSku} | {selectedNameSku}
                  </Descriptions.Item>
                  <Descriptions.Item label="SKU ใหม่" span={3}>
                    {selectedSkunew} | {selectedNameSkunew}
                  </Descriptions.Item>
                </Descriptions>
                <Typography.Title level={3} className="mt-4">
                  ✅ Orders Success
                </Typography.Title>
                {resultJournal.length === 0 ? (
                  <Typography.Text>-</Typography.Text> // แสดง "-" ถ้าไม่มีข้อมูล
                ) : (
                  <List
                    dataSource={resultJournal}
                    renderItem={(o) => (
                      <List.Item>
                        <List.Item.Meta title={<h3>{o.orderNo}</h3>} />
                        <div>JournalID : {o.journalId}</div>
                      </List.Item>
                    )}
                  />
                )}
                <Typography.Title level={3} className="mt-4">
                  ❌ Orders Error
                </Typography.Title>
                {resultJournalerror.length === 0 ? (
                  <Typography.Text>-</Typography.Text> // แสดง "-" ถ้าไม่มีข้อมูล
                ) : (
                  <List
                    dataSource={resultJournalerror}
                    renderItem={(o) => (
                      <List.Item>
                        <List.Item.Meta title={<h3>{o.orderNo}</h3>} />
                      </List.Item>
                    )}
                  />
                )}
              </>
            }
            extra={[
              <Button type="primary" key="console" onClick={handleClear}>
                ยืนยัน
              </Button>,
            ]}
          />
        </Modal>
      )}
    </LoginedLayout>
  );
};

export default EditmultiOrder;
